import { Link } from 'react-router-dom';
import { categories } from '@/mocks/categories';

const colorMap: Record<string, { bg: string; text: string; border: string; iconBg: string }> = {
  accent: {
    bg: 'bg-accent-100',
    text: 'text-accent-800',
    border: 'border-accent-200',
    iconBg: 'bg-accent-500',
  },
  primary: {
    bg: 'bg-primary-100',
    text: 'text-primary-800',
    border: 'border-primary-200',
    iconBg: 'bg-primary-500',
  },
  secondary: {
    bg: 'bg-secondary-100',
    text: 'text-secondary-800',
    border: 'border-secondary-200',
    iconBg: 'bg-secondary-500',
  },
};

export default function CategoryGrid() {
  return (
    <section className="py-14 md:py-20 px-4 md:px-6 bg-background-50">
      <div className="max-w-7xl mx-auto">
        <div className="text-center mb-10 md:mb-14">
          <h2 className="text-2xl md:text-4xl font-bold font-heading text-foreground-900 mb-3">
            热门分类入口
          </h2>
          <p className="text-sm md:text-base text-foreground-600 max-w-xl mx-auto">
            六大频道全天候更新，你想吃的瓜这里全都有
          </p>
        </div>

        <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-6 gap-3 md:gap-4">
          {categories.map((cat) => {
            const colors = colorMap[cat.color] || colorMap.primary;
            return (
              <Link
                key={cat.slug}
                to={`/category/${cat.slug}`}
                className={`group flex flex-col items-center p-4 md:p-6 rounded-lg ${colors.bg} ${colors.border} border transition-all duration-300 hover:scale-[1.03]`}
              >
                <div className={`w-12 h-12 md:w-14 md:h-14 flex items-center justify-center rounded-full ${colors.iconBg} text-background-50 mb-3 md:mb-4 group-hover:shadow-lg transition-shadow duration-300`}>
                  <i className={`${cat.icon} text-lg md:text-xl`}></i>
                </div>
                <h3 className={`text-sm md:text-base font-semibold ${colors.text} mb-1 whitespace-nowrap`}>
                  {cat.name}
                </h3>
                <p className="text-xs text-foreground-500 text-center leading-relaxed line-clamp-2">
                  {cat.description}
                </p>
              </Link>
            );
          })}
        </div>
      </div>
    </section>
  );
}